import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as authUtils from '../auth-utils';
import * as authConsts from '../auth-constants';
import { ToastService } from 'src/app/shared/services/common/toast.service';
import { LoginLoaderService } from 'src/app/shared/services/common/loader.service';
import { AuthConnectService } from '../service/auth-connect.service';
import { LogglyLoggerService } from '@laasy/common-layout';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['../auth-connect/auth-connect.component.scss']
})
export class SigninComponent {
  @Input() SSObutton: any;
  @Input() SSO_val: any;
  @Input() userProfile: { email: string, pass: string } = { pass: '', email: '' };
  @Input() toastMsg: any;
  @Output() routing = new EventEmitter<string>();
  @Output() pass_check = new EventEmitter<any>();
  @Output() toast = new EventEmitter<any>();
  @ViewChild('authForm') signInForm!: NgForm;

  emailRegex = /^[\w.!#$%&'*+/=?^_`{|}~-]+@[\w](?:[\w-]{0,61}[\w])?(?:\.[\w](?:[\w-]{0,61}[\w])?)*$/;
  submitted = false;

  constructor(
    private loginLoader: LoginLoaderService,
    private toastService: ToastService,
    private authconnect:AuthConnectService,
    private loggly: LogglyLoggerService
  ) { }

  navigate(url: string) {
    this.routing.emit(url);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async signIn(form: NgForm) {
    this.submitted = true;
    if(!this.emailRegex.test(this.userProfile.email)) return;
    const { email: ip_email, pass: ip_pass } = this.userProfile;
    this.signInForm.form.markAllAsTouched();
    try {
      if (this.signInForm.valid) {
          if (!(await this.authconnect.checkEmail('signin',this.userProfile.email))) {
            this.loginLoader.showLoginLoader(false);
            return;
          }
          await this.authconnect.userSignIn(ip_email,ip_pass)
      }
    } catch (error) {
      this.loggly.ErrorLog(error as Error);
      this.openToastmsg({
        ...authConsts.error_msg,
        heading: 'Something went wrong',
        text: authUtils.ErrorMsgDict(ip_email, 'Something went wrong signin')
      });
      this.loginLoader.showLoginLoader(false);
    }

  }

  openToastmsg(msg: any) {
    this.toastService.setToast({ ...msg });
  }
}
